module.exports = __webpack_public_path__ + "static/media/LU--black.60e6da3f.svg";